"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _optionProcessor = require("../../../node_modules/@mpxjs/webpack-plugin/lib/runtime/optionProcessor");

var _optionProcessor2 = _interopRequireDefault(_optionProcessor);

var _core = require("@mpxjs/core");

function _interopRequireDefault(obj) {
    try {
        return obj && obj.__esModule ? obj : { default: obj };
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('_interopRequireDefault@@../../../../src/components/common/consumer-hotline.mpx@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
}

var wxsModules = {}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

global.currentSrcMode = "wx";

(0, _core.createComponent)({
  name: 'ConsumerHotLine',
  properties: {
    color: {
      type: String,
      value: '#FFFFFF'
    },
    number: {
      type: String,
      value: '4000000999'
    }
  },
  computed: {
    fontStyle: function fontStyle() {
    try {
        return { color: this.color };
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('fontStyle@@../../../../src/components/common/consumer-hotline.mpx@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
}
  },
  methods: {
    handleCall: function handleCall() {
    try {
        this.triggerEvent('action', {
            type: 'makePhoneCall',
            params: { phone: this.number }
        });
        this.triggerEvent('trackEvent', { type: 'makePhoneCall' });
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('handleCall@@../../../../src/components/common/consumer-hotline.mpx@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
}
  },
  data: function data() {
    try {
        return {};
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('data@@../../../../src/components/common/consumer-hotline.mpx@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
}
});
var currentOption = global.currentOption;
exports.default = (0, _optionProcessor2.default)(currentOption, "component", "", "consumer-hotline58371c7c", {}, // @ts-ignore
{}, // @ts-ignore
{
  'mpx-view': (0, _optionProcessor.getComponent)(require("builtInComponent.vue!=!../../../node_modules/@mpxjs/webpack-plugin/lib/built-in-loader!@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?component=true"), {
    __mpxBuiltIn: true
  })
}, undefined, {}, undefined, (0, _optionProcessor.getWxsMixin)(wxsModules));